




import {SearchResultItem} from '@/model/api/search';
import TransactionFinder from '@/model/TransactionFinder';
import {Component, Inject, Prop, Vue} from 'vue-property-decorator';
import AutocompleteSearchControl from '../common/AutocompleteSearchControl.vue';

@Component({components: {AutocompleteSearchControl}})
export default class TransactionSearchControl extends Vue {
  @Inject({from: 'transactionFinder'})
  public readonly finder: TransactionFinder;

  @Prop({type: Object, default: null})
  public readonly value: SearchResultItem | null;
}
